export const productEmbroideringData = (selectedVariantId, variantTitle, selectedVariantCompareAtPrice)=>{
    let object = {
        embroidery_product: {
            id: '',
            title: '',
            price: '',
            compare_at_price: null
        },
        current_variant: {
            id: '',
            title: '',
            price: '',
            compare_at_price: null
        },
        product: {
            id: '',
            title: ''
        },
        text_configurations: [],
        personalizations: [],
        images: [],
        placements: [],
        colors: [],
        test_image_personalization: ''
    };
    try {
        const dataElement = document.getElementById('product-embroidering-data');
        if (dataElement && dataElement.textContent) {
            object = JSON.parse(dataElement.textContent);
            console.log('Loaded product embroidering data:', object);
            if (object && selectedVariantId) {
                object.current_variant.id = selectedVariantId.toString();
            }
            if (object && variantTitle) {
                object.current_variant.title = variantTitle;
            }
            if (object && selectedVariantCompareAtPrice !== undefined) {
                object.current_variant.compare_at_price = selectedVariantCompareAtPrice;
            }
        }
    } catch (e) {
        console.error('Error loading product embroidering data:', e);
    }
    return object;
};
